import { SEARCH_PROPERTY_STATUS_OFF_MARKET_VALUE } from '../types';

// Logic replicated here: /src/../../../../../app-kit/helpers/searchPages/generateSearchPageSlugFromMultiIntentFilters.ts
export const isPropertyStatusOffMarket = (status: string | undefined): boolean =>
  status === SEARCH_PROPERTY_STATUS_OFF_MARKET_VALUE;
